









































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSBreadcrumb from '../../components/AMSBreadcrumb.vue';
import AMSformTable from '../../components/AMSformTable.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import { AppStore } from '@/store/modules/app';
import AMSProduct from '../../components/AMSProductCategorySelector.vue';
import AMSProductImg from '../../components/AMSProductImg.vue';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSTooltip from '@/components/AMSTooltip.vue';
import utils from '@/utils/utils';
import { getModuleName } from '@/utils/utils';
interface Form {
  filter?: string;
  categoryId?: string;
  status?: string;
  isHidden: string;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-product': AMSProduct,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-brand-selector': AMSBrandSelector,
    'ams-dialog': AMSDialog,
    'ams-tooltip': AMSTooltip
  }
})
export default class ProductStock extends Vue {
  public $refs!: {
    formtable: HTMLFormElement;
  };
  isHidden: boolean = false;
  form = { status: '', categoryId: '', isHidden: '' };
  confirmtype: string | undefined = '';
  BreadItem = [
    {
      text: '商品管理',
      disabled: false,
      href: 'productManage'
    },
    {
      text: '商品列表',
      disabled: true
    }
  ];
  confirmDialog: boolean = false;
  confirmLoading: boolean = false;
  productName: string = '';
  deleteproductId: string = '';
  productStatus: string = '';
  api: string = '/api/Product/List';
  selected = [];
  isSelectAll: boolean = true;
  headers: object[] = [
    { isSelectAll: this.isSelectAll, width: 60, align: 'center', bgColor: { color: '#FFF3F3', field: 'isHidden' } },
    { text: '商品编号', align: 'left', sortable: false, value: 'serialNumber', width: 120, status: 'status', bgColor: { color: '#FFF3F3', field: 'isHidden' } },
    {
      text: '商品',
      align: 'left',
      value: 'name',
      sortable: false,
      render: (h: Function, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row,
            pictureWidth: 40,
            pictureHeight: 40,
            color: utils.stausDiableColor(param.row.status),
            showMark: true
          }
        });
      },
      width: 150,
      bgColor: { color: '#FFF3F3', field: 'isHidden' }
    },
    { text: '容量', align: 'right', value: 'capacity', status: 'status', width: 90, bgColor: { color: '#FFF3F3', field: 'isHidden' } },
    { text: '订货价', align: 'right', value: 'orderPrice', sortable: true, isCurrency: true, width: 120, status: 'status', bgColor: { color: '#FFF3F3', field: 'isHidden' } },
    { text: '库存', align: 'right', value: 'stockQuantity', sortable: true, status: 'status', bgColor: { color: '#FFF3F3', field: 'isHidden' } },
    { text: '排序值', align: 'right', value: 'sort', status: 'status', bgColor: { color: '#FFF3F3', field: 'isHidden' } },
    {
      text: '商品分类',
      align: 'left',
      render: (h: any, param: any) => {
        return h(AMSTooltip, {
          props: {
            content: param.row.category.name,
            width: 100,
            diableColor: utils.stausDiableColor(param.row.status)
          }
        });
      },
      width: 100,
      bgColor: { color: '#FFF3F3', field: 'isHidden' }
    },
    {
      text: '创建时间',
      align: 'left',
      sortable: false,
      value: 'creationTime',
      isFormatDateTimeMM: true,
      width: 160,
      status: 'status',
      bgColor: { color: '#FFF3F3', field: 'isHidden' }
    },
    {
      text: '状态',
      align: 'left',
      sortable: false,
      bgColor: { color: '#FFF3F3', field: 'isHidden' },
      render: (h: any, params: any) => {
        return h(
          'span',
          {
            style: {
              color: params.row.status === 'OnSale' ? '#00A854' : '#999999'
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          params.row.status === 'OnSale' ? '在售' : '未上架'
        );
      },
      width: 80
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      isDetail: [
        {
          routerName: 'productManage_details',
          text: '查看',
          color: '#1ABC9C',
          isParams: true
        },
        {
          routerName: 'productManage_create',
          text: '修改',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return row.status !== 'OnSale' && Utils.isPermission('ProductManager.ProductsList.CreateOrEdit');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'OnSale');
          },
          text: '上架',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return row.status !== 'OnSale' && Utils.isPermission('ProductManager.ProductsList.UpdateStatus');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'StopSale');
          },
          text: '下架',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return row.status !== 'StopSale' && Utils.isPermission('ProductManager.ProductsList.UpdateStatus');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'del');
          },
          text: '删除',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return row.status !== 'OnSale' && Utils.isPermission('ProductManager.ProductsList.Delete');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'hid');
          },
          text: '隐藏',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return Utils.isPermission('ProductManager.ProductsList.Disabled');
          }
        }
      ],
      width: 250,
      bgColor: { color: '#FFF3F3', field: 'isHidden' }
    }
  ];
  statusItems = [
    {
      text: '全部',
      value: ''
    },
    {
      text: '在售',
      value: 'OnSale'
    },
    {
      text: '未上架',
      value: 'StopSale'
    }
  ];
  isSelected: boolean = this.selected.length > 0;
  rules = { name: [] };
  // rowClickData = {
  //   path: 'productManage/details',
  //   key: 'id'
  // };
  changeHidden(val: any) {
    if (val) {
      this.form.isHidden = 'true';
    } else {
      this.form.isHidden = '';
    }
  }
  onStatusClear() {
    setTimeout(() => {
      this.form.status = '';
    }, 1);
  }

  created() {
    this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.isHidden = this.form.isHidden ? true : false;
    }
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  processing(type?: string, val?: any) {
    this.confirmtype = type;
    this.productStatus = val;
    this.confirmDialog = true;
  }
  confirmItem(btn: any, row: any, key: string, type?: string) {
    this.confirmtype = type;
    this.confirmDialog = true;
    this.productName = row.item.name;
    this.deleteproductId = row.item.id;
    this.productStatus = row.item.status;
  }
  selectAll(value: any) {
    (this.$refs.formtable as HTMLFormElement).checkedAll();
  }
  confirmSure() {
    if (this.confirmtype === 'OnSale' || this.confirmtype === 'StopSale') {
      let data = {
        status: this.productStatus === 'OnSale' ? 'StopSale' : 'OnSale',
        productsId: [this.deleteproductId]
      };
      this.upDownProduct(data);
    } else if (this.confirmtype === 'del') {
      const self = this;
      request
        .del(`/api/Product/${this.deleteproductId}`, null)
        .then((data: any) => {
          self.confirmDialog = false;
          self.confirmLoading = false;
          AppStore.ShowSuccess('删除成功！');
          (this.$refs.formtable as HTMLFormElement).query();
        })
        .catch((err: any) => {
          self.confirmDialog = false;
          self.confirmLoading = false;
        });
    } else if (this.confirmtype === 'process') {
      let arr: any = [];
      this.selected.forEach((ele: any) => {
        arr.push(ele.id);
      });
      let data = {
        status: this.productStatus,
        productsId: arr
      };
      this.upDownProduct(data);
    } else if (this.confirmtype === 'hid') {
      const self = this;
      request
        .post(`/api/Product/${this.deleteproductId}/disabled`, null)
        .then((data: any) => {
          self.confirmDialog = false;
          self.confirmLoading = false;
          AppStore.ShowSuccess('隐藏成功！');
          (this.$refs.formtable as HTMLFormElement).query();
        })
        .catch((err: any) => {
          self.confirmDialog = false;
          self.confirmLoading = false;
        });
    }
  }
  upDownProduct(data: any) {
    const self = this;
    let formData = Object.assign({}, data);
    request
      .put(`/api/Product/Status`, formData)
      .then((data: any) => {
        self.confirmDialog = false;
        self.confirmLoading = false;
        this.isSelected = false;
        AppStore.ShowSuccess('操作成功！');
        (self.$refs.formtable as HTMLFormElement).query();
        (self.$refs.formtable as HTMLFormElement).clearSelected();
      })
      .catch(function(err: any) {
        self.confirmDialog = false;
        self.confirmLoading = false;
        AppStore.ShowError('操作失败！');
      });
  }
  confirmClose() {
    this.confirmDialog = false;
  }
  getSelected(val: any) {
    this.selected = val;
  }
  initForm() {
    this.form = { status: '', categoryId: '', isHidden: '' };
    this.isHidden = false;
  }
  newAccount(record: any, type: string) {
    this.$router.push({
      name: 'productManage_create'
    });
  }
  exportAll() {
    this.$router.push({
      path: '/productManage/addExcel'
    });
  }
}
